module.exports = Em.Component.extend({
    classNames: ['additional-info-list']
})
